import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'overviewProjectType'
})
export class OverviewProjectTypePipe implements PipeTransform {
  transform(
    type: string,
    status: string,
    withPlacement: boolean,
    typeMostRecentlyExecuted: string,
    alternative = 'Subproject'
  ): string {
    const printType =
      typeMostRecentlyExecuted == null ? type : typeMostRecentlyExecuted;
    switch (printType) {
      case 'Adjustment':
        return 'Aanpassing';
      case 'SoldRented':
        return 'Verkocht/Verhuurd';
      case 'Repo':
        return 'Weghalen';
      case 'BaseProject':
        return status === 'Uitgevoerd'
          ? 'Uitgevoerd'
          : this.getNewLabel(withPlacement);
      default:
        return alternative;
    }
  }

  getNewLabel(withPlacement: boolean): string {
    if (withPlacement === true) {
      return 'Plaatsing';
    }
    if (withPlacement === false) {
      return 'Afhaling';
    }
    return 'Nieuw';
  }
}
